module.exports = __webpack_public_path__ + "img/ltkfamily-2x.ae48024.jpg";